<template>
  <div class="company-selector">
    <v-card class="px-6 pt-6 pb-6">
      <v-card-title class="px-0 pb-4">
        <v-img lazy-src="@/assets/logo.png" max-height="24" max-width="32" src="@/assets/logo.png"></v-img>
        <div class="vertical-divider mx-2"></div>
        <span class="xx-toolbar-title"> {{ $t('GLN.setGLN') }} </span>
      </v-card-title>
      <v-card-text class="px-0 pb-4">
        <v-autocomplete
          :loading="loading"
          v-model="selectedClient"
          :items="clientsList"
          item-text="companyName"
          item-value="companyName"
          :filter="customFilter"
          return-object
          :placeholder="$t('GLN.companyPlaceholder')"
          outlined
          dense
        >
          <template v-slot:item="data">
            <div class="client-list-item py-2">
              <span class="font-weight-light">{{ data.item.companyName }}</span>
              <br />
              <span class="primary--text font-weight-medium">{{ data.item.informationProvider }}</span>
            </div>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions class="px-0 pt-0">
        <v-btn
          v-if="showCancel"
          text
          @click="handleCancel"
          class="mr-2"
        >
          {{ $t('IMPORT_FILE.cancel') }}
        </v-btn>
        <v-btn
          :disabled="!selectedClient"
          class="btn login-action-btn"
          color="primary"
          @click="handleConfirm"
          block
        >
          {{ $t('GLN.setGLN') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-alert
      v-if="clientsListError"
      transition="scroll-y-transition"
      prominent
      dismissible
      type="error"
      class="company-selector-alert"
    >
      <v-row align="center">
        <v-col class="grow">
          <p>
            {{ clientsListError.error }}
          </p>
          <p>
            {{ clientsListError.message }}
          </p>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import CompanyService from '@/api/company/companyService.js';

export default {
  name: 'CompanySelector',

  props: {
    showCancel: {
      type: Boolean,
      default: false
    },
    onConfirm: {
      type: Function,
      default: null
    },
    initialCompany: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      clientsList: null,
      selectedClient: null,
      clientsListError: null
    };
  },

  created() {
    this.getClientsList();
    if (this.initialCompany) {
      this.selectedClient = this.initialCompany;
    } else {
      this.selectedClient = JSON.parse(localStorage.getItem('client'));
    }
  },

  methods: {
    customFilter(item, queryText) {
      if (!item.companyName || !item.informationProvider) {
        return false;
      }
      const filterOne = item.companyName.toLowerCase();
      const filterTwo = item.informationProvider.toLowerCase();
      const searchText = queryText.toLowerCase();

      return filterOne.includes(searchText) || filterTwo.includes(searchText);
    },

    async getClientsList() {
      try {
        this.loading = true;
        const res = await CompanyService.getClientsList();
        this.clientsList = res.data;
      } catch (error) {
        console.log('Cant get clients list');
        if (!error.response) {
          this.clientsListError = {
            error: 'Failed',
            message: 'Connection timeout'
          };
        } else {
          this.clientsListError = error.response.data;
        }

        setTimeout(() => {
          this.clientsListError = null;
        }, 7000);
      } finally {
        this.loading = false;
      }
    },

    handleConfirm() {
      if (this.onConfirm) {
        this.onConfirm(this.selectedClient);
      }
      this.$emit('company-selected', this.selectedClient);
    },

    handleCancel() {
      this.$emit('cancelled');
    }
  }
};
</script>

<style lang="scss" scoped>
.company-selector {
  .vertical-divider {
    height: 24px;
    border-left: 1px solid lightgrey;
  }

  .login-action-btn {
    width: 100%;
  }

  .company-selector-alert {
    max-width: 500px;
    position: fixed;
    bottom: 12%;
    right: 1%;
    z-index: 99;
  }
}
</style>
